export default __webpack_public_path__ + "static/media/i097hk.0e36317b.webp";